module.exports = __webpack_public_path__ + "static/img/5.1.47988e4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/zh/5.1.png
// module id = fvD7
// module chunks = 0